export const avg = (arr) => {
  let goldAvg = 0.0;
  let silverAvg = 0.0;
  let bronzeAvg = 0.0;
  let len = arr.length;
  for (let i = 0; i < len; i++) {
    const { Gold: gold, Silver: silver, Bronze: bronze } = arr[i];
    goldAvg += gold;
    silverAvg += silver;
    bronzeAvg += bronze;
  }
  if (len > 0) {
    goldAvg /= len;
    silverAvg /= len;
    bronzeAvg /= len;
  }

  goldAvg = goldAvg?.toFixed(1);
  silverAvg = silverAvg?.toFixed(1);
  bronzeAvg = bronzeAvg?.toFixed(1);
  return { goldAvg, silverAvg, bronzeAvg };
};
